export default __webpack_public_path__ + "static/media/applicant_applied.9d280f42.svg";